// global
import React, { Component } from 'react';
import { Popup, Image, Grid } from 'semantic-ui-react';
// local
// css
import './MapLabel.scss';
// image
import ic_flow_alert_gray from 'app/_assets/img/ic_flow_alert_gray.png';

const Content = () => {
    return (
        <Grid columns={2}>
            <Grid.Row>
                <Grid.Column id="state">
                    <div className="column-title">ESTADO</div>
                    <div className="device-row">
                        <div className='device-info open' /> Fluxo Aberto
                    </div>
                    <div className="device-row">
                        <div className='device-info flow-off' /> Fluxo Fechado
                    </div>
                    <div className="device-row">
                        <div className='device-info low-bat' /> Bateria Baixa
                    </div>
                    {/* <div className="device-row">
                        <div className='device-info off' /> Desligado
                    </div> */}
                </Grid.Column>
                <Grid.Column id="type">
                    <div className="column-title">TIPO</div>
                    <div className="device-row">
                        <div className='device-info adult' /> Adulto
                    </div>
                    <div className="device-row">
                        <div className='device-info concentrator' /> Concentrador
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

class MapLabel extends Component {
    render() {
        return (
            <Popup id="popup-map-legend" trigger={<Image id="popup-map-legend-trigger" src={ic_flow_alert_gray} />} content={<Content />} />
        );
    }
}

export default MapLabel;
